// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  containerId: __t.u64().primaryKey().name("container_id"),
  leaseId: __t.u64().name("lease_id"),
  structureId: __t.u64().name("structure_id"),
  tenant: __t.identity(),
  key: __t.string(),
  kind: __t.string(),
  capacity: __t.u32(),
  createdAt: __t.timestamp().name("created_at"),
});
